module.exports = __webpack_public_path__ + "static/media/html-tag-icon.5108dfda.png";